/**
 * BuddyPress components.
 */
import AutoCompleter from './autocompleter';
import ServerSideRender from './server-side-render';

export default {
	AutoCompleter,
	ServerSideRender,
};
